
import Vue from 'vue'
import i18n, { languages } from '@/plugins/i18n'

export default Vue.extend({
  name: 'LanguageSelector',
  data() {
    return {
      locale: i18n.locale,
      // 原本的語言列表（從 i18n 引入）
      // languages

      // 新的語言列表（包含國旗）
      languages: [
        { text: 'English', value: 'en', flag: '🇺🇸' },
        { text: '繁體中文', value: 'zh', flag: '🇹🇼' },
        { text: '日本語', value: 'ja', flag: '🇯🇵' }
      ]
    }
  },
  methods: {
    // 原本的方法
    // change() {
    //   i18n.locale = this.locale
    //   localStorage.setItem('locale', this.locale)
    // }

    // 新的方法
    changeLanguage(locale: string) {
      this.locale = locale
      i18n.locale = locale
      localStorage.setItem('locale', locale)
    }
  }
})
